import {
  SUPPORT_ACTION_STATUSES as SharedSupportActionStatuses,
  SUPPORT_ACTION_TYPES as SharedSupportActionTypes,
} from "shared/dist/types/SupportAction";

import type {
  SupportAction as SharedSupportAction,
  SupportActionStatus,
  SupportActionType,
} from "shared/dist/types/SupportAction";

export type {
  SupportActionStatus,
  SupportActionType
};

export const SUPPORT_ACTION_STATUSES = SharedSupportActionStatuses;
export const SUPPORT_ACTION_TYPES = SharedSupportActionTypes;

export default interface SupportAction extends SharedSupportAction {}